/* ============================================================
   丸型トリミングエディタ — PICTURE GOODS STORE
   アップロード画像を拡大縮小・移動し、円形範囲で切り抜いて
   PNG（透過・円形）として Cloudflare R2 に保存する。
   保存は pgs.js が公開する window.PGSUpload（Workers への
   multipart/form-data POST）に委譲し、再試行・タイムアウトの扱いを
   通常のアップロードと揃える。

   - ドラッグ（マウス / タッチ）で移動
   - スライダー / ＋−ボタン / ホイール / 2本指ピンチで拡大縮小
   - 切り抜き範囲（円）が常に画像で覆われるようパン・ズームをクランプ
   - 保存成功時に CustomEvent 'pgs:roundcrop' を発火
       detail: { url: <R2の公開URL>, dataUrl: <即時表示用dataURL>, name: <保存名> }
     → pgs.js 側が丸型キーホルダーカードへ反映・購入ボタンを有効化する

   マークアップは snippets/pgs-round-editor.liquid、
   スタイルは assets/pgs-round-editor.css を参照。
   ============================================================ */
(function () {
  "use strict";

  var CROP_RATIO = 0.82;   /* 円の直径 / ビューポート幅（CSS .re-mask と一致させる） */
  var OUT_SIZE = 1024;     /* 書き出しPNGの一辺(px) */
  var MAX_ZOOM_FACTOR = 6; /* 最小スケールに対する最大倍率 */

  var veil, modal, stage, canvas, ctx, maskEl, emptyEl, slider, statusEl, fileInput;
  var img = null;              /* 編集対象 HTMLImageElement */
  var baseName = "image";      /* 保存ファイル名用 */
  var view = 320;              /* ビューポートのCSSピクセル幅（open時に計測） */
  var state = { scale: 1, min: 1, max: 6, x: 0, y: 0 };
  var pointers = new Map();    /* ピンチ/ドラッグ用 */
  var lastDist = 0;
  var loadRevision = 0;        /* 遅れて完了した旧画像の読み込みを破棄する */

  function $(sel, root) { return (root || document).querySelector(sel); }

  /* ---------- 起動時に一度だけ DOM を取得 ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    veil = $("#reVeil"); modal = $("#reModal");
    if (!modal) return; /* エディタ未設置ページ */
    stage = $("#reStage"); canvas = $("#reCanvas"); ctx = canvas.getContext("2d");
    maskEl = $(".re-mask", modal); emptyEl = $("#reEmpty");
    slider = $("#reZoom"); statusEl = $("#reStatus"); fileInput = $("#reFile");

    /* 開くボタン（商品カード側）: 現在のプレビュー画像があればそれを初期表示 */
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-open-round-editor]");
      if (opener) openEditor();
    });

    $("#reClose").addEventListener("click", closeEditor);
    veil.addEventListener("click", closeEditor);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("open")) closeEditor();
    });

    /* 画像選択（エディタ内） */
    $("#rePick").addEventListener("click", function () { fileInput.click(); });
    $("#reEmptyPick").addEventListener("click", function () { fileInput.click(); });
    fileInput.addEventListener("change", function () {
      if (fileInput.files.length) loadFromFile(fileInput.files[0]);
      fileInput.value = "";
    });

    /* ズーム操作 */
    slider.addEventListener("input", function () {
      zoomAt(view / 2, view / 2, parseFloat(slider.value));
    });
    $("#reZoomIn").addEventListener("click", function () { zoomAt(view / 2, view / 2, state.scale * 1.15); });
    $("#reZoomOut").addEventListener("click", function () { zoomAt(view / 2, view / 2, state.scale / 1.15); });
    stage.addEventListener("wheel", function (e) {
      if (!img) return;
      e.preventDefault();
      var p = localPoint(e);
      zoomAt(p.x, p.y, state.scale * Math.pow(1.0015, -e.deltaY));
    }, { passive: false });

    /* ドラッグ / ピンチ（Pointer Events でマウス・タッチ共通処理） */
    stage.addEventListener("pointerdown", function (e) {
      if (!img) return;
      stage.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, localPoint(e));
      if (pointers.size === 2) lastDist = pinchDist();
      stage.classList.add("dragging");
    });
    stage.addEventListener("pointermove", function (e) {
      if (!img || !pointers.has(e.pointerId)) return;
      var prev = pointers.get(e.pointerId);
      var cur = localPoint(e);
      pointers.set(e.pointerId, cur);

      if (pointers.size === 1) {
        state.x += cur.x - prev.x;
        state.y += cur.y - prev.y;
        clampPan();
        draw();
      } else if (pointers.size === 2) {
        var d = pinchDist();
        if (lastDist > 0) {
          var pts = Array.from(pointers.values());
          var mid = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
          zoomAt(mid.x, mid.y, state.scale * (d / lastDist));
        }
        lastDist = d;
      }
    });
    function endPointer(e) {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) lastDist = 0;
      if (pointers.size === 0) stage.classList.remove("dragging");
    }
    stage.addEventListener("pointerup", endPointer);
    stage.addEventListener("pointercancel", endPointer);

    $("#reCrop").addEventListener("click", cropAndUpload);
  });

  function localPoint(e) {
    var r = stage.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  }
  function pinchDist() {
    var pts = Array.from(pointers.values());
    return Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
  }

  /* ---------- 開閉 ---------- */
  var lastGlobalSrc = null; /* 前回エディタに取り込んだ「サイト全体のプレビュー画像」 */

  function openEditor() {
    veil.classList.add("open");
    modal.classList.add("open");
    view = stage.clientWidth || 320;
    syncCanvasSize();
    /* アップロード済み画像（?image= クエリからの復元を含む）があれば取り込む。
       pgs.js が window.PGSPreview = {src, fileName} を常に最新へ更新している。
       - サイト側の画像が前回から変わっていれば、エディタ内の画像を差し替える
       - 変わっていなければ、エディタ内で選び直した画像や調整状態を維持する */
    var pv = window.PGSPreview || {};
    if (pv.src && pv.src !== lastGlobalSrc) {
      lastGlobalSrc = pv.src;
      baseName = (pv.fileName || "image").replace(/\.[^.]+$/, "");
      loadImage(pv.src);
    } else {
      draw();
    }
  }
  function closeEditor() {
    veil.classList.remove("open");
    modal.classList.remove("open");
    setStatus(null);
  }

  function syncCanvasSize() {
    var dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(view * dpr);
    canvas.height = Math.round(view * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  /* ---------- 画像読み込み ---------- */
  function loadFromFile(file) {
    if (!/^image\//.test(file.type)) { setStatus("error", "画像ファイルを選択してください"); return; }
    if (file.size > 20 * 1024 * 1024) { setStatus("error", "20MB以下の画像を選択してください"); return; }
    baseName = (file.name || "image").replace(/\.[^.]+$/, "");
    var reader = new FileReader();
    reader.onload = function (e) { loadImage(e.target.result); };
    reader.readAsDataURL(file);
  }

  function loadImage(src) {
    /* リモート画像（?image= クエリからの復元）は canvas を汚染しうるため、
       pgs.js の window.PGSRemote 経由で dataURL 化してから読み込む
       （R2 は fetch → Blob、旧 Drive URL は GAS プロキシ経由） */
    var revision = ++loadRevision;
    var prepare;
    if (/^data:/.test(src)) {
      prepare = Promise.resolve(src);
    } else if (window.PGSRemote && window.PGSRemote.asDataUrl) {
      setStatus("uploading", "アップロード済みの画像を読み込んでいます…");
      prepare = window.PGSRemote.asDataUrl(src);
    } else {
      prepare = Promise.resolve(src);
    }

    prepare.then(function (usableSrc) {
      if (revision !== loadRevision) return;
      var im = new Image();
      if (!/^data:/.test(usableSrc)) im.crossOrigin = "anonymous"; /* 念のため（同一オリジン等） */
      im.onload = function () {
        if (revision !== loadRevision) return;
        img = im;
      emptyEl.classList.add("hidden");
      /* スケール設計:
         cover = 円形範囲を完全に覆う最小倍率（既定値。中央切り抜きの標準状態）
         fit   = 画像全体がエディタ内に収まる倍率（フルサイズ表示）
         最小値は fit の 1/2 まで許可 → 全体表示からさらに縮小でき、
         円より小さく配置した部分の余白は透明として書き出される */
      var d = view * CROP_RATIO;
      var cover = Math.max(d / img.naturalWidth, d / img.naturalHeight);
      var fit = Math.min(view / img.naturalWidth, view / img.naturalHeight);
      state.min = Math.min(cover, fit * 0.5);
      state.max = cover * MAX_ZOOM_FACTOR;
      state.scale = cover; /* 既定は従来どおり「円を覆う」倍率でスタート */
      slider.min = state.min; slider.max = state.max;
      slider.step = (state.max - state.min) / 200;
      slider.value = state.scale;
        /* 中央配置 */
        state.x = (view - img.naturalWidth * state.scale) / 2;
        state.y = (view - img.naturalHeight * state.scale) / 2;
        setStatus(null);
        draw();
      };
      im.onerror = function () {
        if (revision !== loadRevision) return;
        setStatus("error", "画像を読み込めませんでした。「別の画像を選ぶ」からファイルを選択してください。");
      };
      im.src = usableSrc;
    }).catch(function (err) {
      if (revision !== loadRevision) return;
      console.error("editor image load error:", err);
      setStatus("error", "画像を読み込めませんでした。" + (err && err.message ? err.message + "。" : "") + "「別の画像を選ぶ」からファイルを選択してください。");
    });
  }

  /* ---------- 描画 ---------- */
  function draw() {
    ctx.clearRect(0, 0, view, view);
    if (!img) return;
    ctx.drawImage(img, state.x, state.y, img.naturalWidth * state.scale, img.naturalHeight * state.scale);
  }

  /* ---------- ズーム（指定点を固定して拡縮） ---------- */
  function zoomAt(cx, cy, newScale) {
    if (!img) return;
    newScale = Math.max(state.min, Math.min(state.max, newScale));
    var k = newScale / state.scale;
    state.x = cx - (cx - state.x) * k;
    state.y = cy - (cy - state.y) * k;
    state.scale = newScale;
    slider.value = newScale;
    clampPan();
    draw();
  }

  /* ---------- パンのクランプ ----------
     ・画像が円形範囲より大きい辺 → 円を必ず覆う（従来どおり）
     ・画像が円形範囲より小さい辺 → 画像が円の枠内に収まる
     どちらも lo=min(c-r, c+r-サイズ), hi=max(…) の1つの式で表せる
     その範囲を中心はそのままに PAN_RANGE_FACTOR 倍へ広げる
     （はみ出した部分は透明として書き出される）
     画像の辺が円の直径とほぼ同じだと範囲が 0 になり動かせないため、
     中心から少なくとも 半径×MIN_PAN_RATIO は動かせるようにする */
  var PAN_RANGE_FACTOR = 2;
  var MIN_PAN_RATIO = 0.5;
  function clampPan() {
    var c = view / 2, r = view * CROP_RATIO / 2;
    var w = img.naturalWidth * state.scale, h = img.naturalHeight * state.scale;
    var x = expandRange(c - r, c + r - w, r), y = expandRange(c - r, c + r - h, r);
    state.x = Math.min(x.hi, Math.max(x.lo, state.x));
    state.y = Math.min(y.hi, Math.max(y.lo, state.y));
  }
  function expandRange(a, b, r) {
    var mid = (a + b) / 2;
    var half = Math.max(Math.abs(a - b) / 2 * PAN_RANGE_FACTOR, r * MIN_PAN_RATIO);
    return { lo: mid - half, hi: mid + half };
  }

  /* ---------- 切り抜き → R2 保存 ---------- */
  function cropAndUpload() {
    if (!img) { setStatus("error", "先に画像を選択してください"); return; }

    var c = view / 2, r = view * CROP_RATIO / 2;

    var out = document.createElement("canvas");
    out.width = OUT_SIZE; out.height = OUT_SIZE;
    var octx = out.getContext("2d");
    octx.beginPath();
    octx.arc(OUT_SIZE / 2, OUT_SIZE / 2, OUT_SIZE / 2, 0, Math.PI * 2);
    octx.closePath();
    octx.clip();
    /* ビューポート座標 → 出力キャンバス座標へ写像し「転送先指定」で描画。
       画像を円形範囲より小さく配置した場合も、余白（透明）を正しく再現できる */
    var k = OUT_SIZE / (2 * r);
    octx.drawImage(
      img,
      (state.x - (c - r)) * k,
      (state.y - (c - r)) * k,
      img.naturalWidth * state.scale * k,
      img.naturalHeight * state.scale * k
    );

    var dataUrl;
    try {
      dataUrl = out.toDataURL("image/png");
    } catch (e) {
      /* CORS で canvas が汚染されている場合 */
      setStatus("error", "この画像は加工できません。「別の画像を選ぶ」から端末内のファイルを直接選択してください。");
      return;
    }

    /* 保存は pgs.js の共通アップローダ（Cloudflare Workers → R2）に委譲する。
       dataURL は内部で Blob へ戻され、multipart/form-data で送信される。 */
    var uploader = window.PGSUpload;
    if (!uploader || !uploader.dataUrl) {
      setStatus("error", "アップロード機能を初期化できませんでした。ページを再読み込みしてお試しください。");
      return;
    }

    var btn = $("#reCrop");
    btn.disabled = true;
    setStatus("uploading", "切り抜いた画像を保存しています…");

    uploader.dataUrl(dataUrl, "round_" + baseName + ".png", "丸型切り抜き保存")
      .then(function (json) {
        setStatus(null);
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent("pgs:roundcrop", {
          detail: { url: json.url, dataUrl: dataUrl, name: json.name || "" }
        }));
        closeEditor();
      })
      .catch(function (err) {
        console.error("round crop upload error:", err);
        btn.disabled = false;
        setStatus("error", "保存に失敗しました。" + (err && err.message ? err.message : "通信環境をご確認のうえ、もう一度お試しください。"));
      });
  }

  /* ---------- ステータス表示 ---------- */
  function setStatus(kind, msg) {
    if (!statusEl) return;
    if (!kind) { statusEl.className = "re-status"; statusEl.innerHTML = ""; return; }
    statusEl.className = "re-status show is-" + kind;
    statusEl.innerHTML =
      (kind === "uploading" ? "<span class='spinner' aria-hidden='true'></span>" : "<span aria-hidden='true'>！</span>") +
      "<span></span>";
    statusEl.querySelector("span:last-child").textContent = msg;
  }
})();
